import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

/**
 * Returns whether the current user has access to a feature flag.
 * The check is delegated to the `has_feature` SQL function which
 * accounts for global flags, admin override and the `tester` role.
 */
export function useFeatureFlag(key: string) {
  const { user, loading: authLoading } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["feature_flag", key, user?.id ?? "anon"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("has_feature", { _key: key });
      if (error) {
        console.error(`has_feature(${key}) error:`, error);
        return false;
      }
      return !!data;
    },
    enabled: !authLoading,
    staleTime: 1000 * 60 * 2,
  });

  return {
    enabled: !!data,
    loading: authLoading || isLoading,
  };
}
